import { schema } from 'normalizr';
import { MentoringProgramEnrollment } from 'redux/schemas/models/mentoring-program-enrollments';

export const MentoringProgramEnrollmentSchema = new schema.Entity<MentoringProgramEnrollment>('mentoringProgramEnrollments');

export const MentoringProgramEnrollmentsSchema = new schema.Array(MentoringProgramEnrollmentSchema);
